import { render, staticRenderFns } from "./b-end.vue?vue&type=template&id=092fe665&scoped=true&"
import script from "./b-end.vue?vue&type=script&lang=js&"
export * from "./b-end.vue?vue&type=script&lang=js&"
import style0 from "./b-end.vue?vue&type=style&index=0&id=092fe665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092fe665",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType4: require('D:/Project/kpwebsite/PC/components/content/content-type-4.vue').default,ContentType3: require('D:/Project/kpwebsite/PC/components/content/content-type-3.vue').default})
